export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9981.f4cd605d.jpg";